import { createContext } from 'react';
export const CustomerPrivacySecurityContext = /*#__PURE__*/createContext({
  areAllSectionsExpanded: false,
  setAreAllSectionsExpanded: () => null
});